import { render, staticRenderFns } from "./QuotaholdersPL.vue?vue&type=template&id=f50a1c94&"
import script from "./QuotaholdersPL.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersPL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports